import React from 'react'
import getFormatedPrice from "../func/getFormatedPrice";
import getItemsWithPrice from "../func/getItemsWithPrice";
import getTotalPrice from "../func/getTotalPrice";

const EditEventFormPrintTotalTotal = ({eventData, form_settings}) => {
    const visitors = getItemsWithPrice(eventData, form_settings, "visitors", false);
    const visitorsFees = getItemsWithPrice(eventData, form_settings, "visitors_other_fees", visitors);
    const theatres = getItemsWithPrice(eventData, form_settings, "theatres", false);
    const theatresFees = getItemsWithPrice(eventData, form_settings, "theatres_other_fees", theatres);
    const totalTotal = getTotalPrice(visitors, visitorsFees, theatres, theatresFees, eventData.extra_price)

    return (
        <div className="container-2-1 margin-top-total">
            <span className="text-regular">Gesamtsumme:</span> 
            <span>
                <span className="double-underline text-small-light">= {getFormatedPrice(totalTotal)}</span>
            </span>
        </div>
    )
}

export default EditEventFormPrintTotalTotal